export enum CLIENT_TYPES {
  AUTH_CLIENT = 'v1_auth',
  NAVIGATION_CLIENT = 'v1_navigation',
  DYNAMIC_MENU_CLIENT = 'v1_dynamic_menu',
  ROLE_BASED_ACCESS_CLIENT = 'v1_role_based_access_menu',
  REPORT_CLIENT = 'v1_report_client',
  NOTIFICATION_CLIENT = 'v1_notification',
  MERCHANDISING_CLIENT = 'v1_merchandising',
  SCM_CLIENT = 'v1_scm',
  ACCESS_CONTROL_MANAGEMENT = 'v1_access_control_management',
  FEEDBACK_AND_SUGGESTION = 'v1_feedback_and_suggestion',
  HELP_AND_SUPPORT = 'v1_help_and_support',
  SUPPLIER_CLIENT = 'v1_supplier',
  BOOKING_CLIENT = 'v1_booking',
  HRMS_CLIENT = 'v1_hrms',
  UTIL_CLIENT = 'v1_utils',
}
